/* Optional fundraiser donation add-on. Standalone for the same reason as
   freebie.js: theme.min.js is what the page loads, so theme.js is not
   editable. Contract with the theme (verified in theme.js):
   - 'ajaxProduct:added' fires after the product form's own /cart/add lands;
     the cart drawer listens to it, rebuilds, and opens.
   - dispatching 'cart:build' rebuilds the drawer silently.
   So this file adds its donation line AFTER the theme's add, then fires
   'cart:build' to pull the new line into the already-open drawer. */
(function() {
  var busy = false;

  function selectedVariantId() {
    var root = document.querySelector('[data-donation-root]');
    if (!root) return null;
    var select = root.querySelector('select[name="donation-amount"]');
    return select && select.value ? select.value : null;
  }

  // Money path: never let a second add-to-cart stack a second donation.
  function cartHasDonation() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        return cart.items.some(function(item) {
          return item.properties && item.properties._donation === 'true';
        });
      });
  }

  function addDonation(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: { _donation: 'true' }
      })
    }).then(function(r) { if (!r.ok) throw r; return r; });
  }

  document.addEventListener('ajaxProduct:added', function() {
    if (busy) return;
    var variantId = selectedVariantId();
    if (!variantId) return;
    busy = true;

    cartHasDonation()
      .then(function(already) {
        if (already) return null;
        return addDonation(variantId).then(function() {
          document.dispatchEvent(new CustomEvent('cart:build'));
        });
      })
      .then(function() { busy = false; }, function() { busy = false; });
  });
}());
